import { Checkbox } from 'antd'
import styled from 'styled-components'

export const RiskActionStyle = styled.div`
  h6 {
    font-size: 14px !important;
  }

  .cvlgNk > div > p {
    margin-bottom: 10px !important;
  }
`
export const CheckboxWrapper = styled.span`
  pointer-events: none !important;
`
